export const getColumnBorderFlags = (
  columnIds: string[],
  columnIndex: number | undefined,
  firstColumnIds: Set<string>,
  lastColumnIds: Set<string>,
  hasScroll: boolean | undefined,
): { isFirst: boolean; isLast: boolean } => {
  const totalColumns = columnIds.length;
  const columnId = typeof columnIndex === 'number' ? columnIds[columnIndex] : undefined;
  // Name column is the row label; a left rule there sits inside its padding and looks wrong.
  const isNameColumn = Boolean(columnId && /^name_\d+$/.test(columnId));

  // Always draw a left separator after the leading order/name columns so wide tables keep
  // consistent column lines across the full width (not only at group "firstItems" boundaries).
  const isFirst =
    typeof columnIndex === 'number'
      ? columnIndex > 0 && !isNameColumn
      : Boolean(columnId && firstColumnIds.has(columnId));

  const isLastCandidate = columnId ? lastColumnIds.has(columnId) : false;
  const isLast =
    isLastCandidate && (typeof columnIndex === 'number' ? columnIndex !== totalColumns - 1 || !!hasScroll : true);

  return { isFirst, isLast };
};
